var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',[_c('WsCRUD',{attrs:{"pageMode":"","rowClickRead":"","label":_vm.label,"fields":_vm.fields,"sortBy":_vm.sortBy,"showExpand":false,"modelName":_vm.modelName,"showFields":_vm.showFields,"filterSelects":_vm.filterSelects}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }